import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

/**
 * Dialog de confirmação genérico (não-destrutivo) — substitui os 3 dialogs
 * manuais em AppointmentsPage (confirmar, atendido, cancelar) e qualquer
 * outro fluxo de confirmação simples.
 *
 * Para operações destrutivas (deletar), use DeleteConfirmDialog ou CascadeDeleteDialog.
 * Para operações em cascata, use CascadeDeleteDialog.
 *
 * @param {boolean}  open           - Visibilidade do dialog
 * @param {Function} onClose        - Callback ao fechar/cancelar
 * @param {Function} onConfirm      - Callback ao confirmar
 * @param {string}   title          - Título do dialog
 * @param {ReactNode} message       - Conteúdo descritivo (pode incluir <strong>)
 * @param {string}   [confirmText]  - Texto do botão de confirmação (default: 'Confirmar')
 * @param {string}   [cancelText]   - Texto do botão de cancelamento (default: 'Cancelar')
 * @param {string}   [confirmColor] - Cor MUI do botão de confirmação (default: 'primary')
 *
 * @example
 * const confirmDialog = useDialog();
 *
 * <ConfirmDialog
 *   open={confirmDialog.open}
 *   onClose={confirmDialog.handleClose}
 *   onConfirm={handleConfirm}
 *   title="Confirmar Agendamento"
 *   message={<>Confirmar agendamento de <strong>{name}</strong>?</>}
 *   confirmText="Confirmar"
 *   confirmColor="success"
 * />
 */
export default function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  confirmColor = 'primary',
}) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText component="div">{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{cancelText}</Button>
        <Button onClick={onConfirm} variant="contained" color={confirmColor}>
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
